import React, { useEffect } from 'react'
import InvoiceContainer from '../InvoiceContainer/InvoiceContainer'
import { useDispatch, useSelector } from 'react-redux';
import "./OrderDetailsContainer.css"
import { fetchCity } from '../../hooks/cities';
function OrderDetailsContainer({ order }) {
  const dispatch=useDispatch()
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const {city:cities}  = useSelector((state) => state.cities);
  const cityData=cities?.find((item)=>item?.id==order[0]?.client_city)
useEffect(() => {
dispatch(fetchCity())
}, [])
  return (
    <div className='edite_container'>

      <div className='d-flex justify-content-between order_details_container'>
        <div>
          <p className='fw-bold'>{currentLocal.home.order_no} : <span className='fw-normal'>{order[0]?.order_no}</span></p>
          <p className='text-muted fw-bold'>{currentLocal.home.date} :{order && order[0]?.created_at && order[0]?.created_at.substring(0, 10)}</p>
          <p className='fw-bold'>{currentLocal.home.orderStatus} :<span className='fw-normal'>{order[0]?.status?.id == 3 ? "proccing" : order[0]?.status?.id == 4 ? "shipped" : order[0]?.status?.id == 5 ? "Delivered" : "Pinding"}

          </span></p>

        </div>
        <div>
          <p className='fw-bold'>{currentLocal.home.namePlaceholder} : <span className='fw-normal'>{order[0]?.client?.name}</span></p>
          <p className='fw-bold'>{currentLocal.home.phone} : <span className='fw-normal'>{order[0]?.client?.phone}</span></p>
          {/* <p className='text-muted fw-bold'>Address :{order && order.shippingAddress.addressLine1}{order && order.shippingAddress.addressLine2}</p> */}
          <p className='fw-bold'><span className='fw-normal'>
             <span className='fw-bold mx-1'> {currentLocal.home.buildingNumber}: </span>{order[0] && order[0]?.client_house_number} ,
             <span className='fw-bold mx-1'> {currentLocal.home.buildingNumber}: </span>{order[0] && order[0]?.client_block} ,
             <span className='fw-bold mx-1'>{currentLocal.home.street}: </span>{order?.[0] && order[0]?.client_street}  ,
             <span className='fw-bold mx-1'>{currentLocal.home.region}:</span> {order?.[0] && order[0]?.client_region} 
             <span className='fw-bold mx-1'>{currentLocal.home.city}:</span> {cityData?.name} 
             </span>
          
          </p>
          <p className='fw-bold'>{currentLocal.home.address} :<span className='fw-normal'>  {order[0] && order[0]?.client_address_notes}</span></p>
          <p className='fw-bold'>{currentLocal.home.notes} :<span className='fw-normal'>  {order[0] && order[0]?.note}</span></p>

        </div>
        <div>
          <InvoiceContainer
            trackingNumber={order[0]?.order_no}
            createdAt={order && order[0]?.created_at && order[0]?.created_at.substring(0, 10)}
            total={order?.[0]?.total}
            paymentMethod={order[0]?.payment_method}
            address1={order?.[0]?.client_address_notes}
            note={order?.[0]?.note}
            subtotal={order?.[0]?.subtotal}
            name={order[0]?.client?.name}
            address2={
              order[0]?.address
                ? `${order[0]?.address.house_number || ""}, ${order[0]?.client_block || ""}, ${order[0]?.address.street || ""}`
                : ""
            }
            phone={order[0]?.client?.phone}
            city={cityData?.name}
            region={order[0]?.client_region}
            street={order[0]?.client_street}
            block={order[0]?.client_block}
            house_number={order[0]?.client_house_number}
            items={order?.[0]?.details}
            shippingAmount={order?.[0]?.delivery_fee}

          />
        </div>
      </div>


      <table className='table table-hover table-borderless table-thead-bordered table-nowrap table-align-middle card-table w-100 text-start  py-5 border-bottom border-top mt-5'>
        <thead className="thead-light thead-50 text-capitalize">
          <tr>
            <th>{currentLocal.home.ID}</th>
            <th >{currentLocal.home.namePlaceholder}</th>
            <th >{currentLocal.home.price}</th>
            <th >{currentLocal.home.Priceafterdiscound}</th>

            <th >{currentLocal.home.colors}</th>
            <th >{currentLocal.home.Sizes}</th>
            <th >{currentLocal.home.Quantity}</th>

          </tr>
        </thead>

        <tbody>
          {order[0] && order?.[0]?.details.map((item, index) => {
            
            return (
              <tr key={index}>
                <td>{index + 1}</td>

                <td className="overflow-hidden max-width-100px">
                  <span data-toggle="tooltip" data-placement="right" title="" data-original-title="Keithston">

                    {item.product.name_en}
                  </span>
                </td>
                <td className="overflow-hidden max-width-100px">
                  <span data-toggle="tooltip" data-placement="right" title="" data-original-title="Keithston">

                    {item.product?.price_egp}{currentLocal.home.egp}
                  </span>
                </td>
                <td className="overflow-hidden max-width-100px">
                  <span data-toggle="tooltip" data-placement="right" title="" data-original-title="Keithston">

                    {item.product?.discounted_price_egp}{currentLocal.home.egp}
                  </span>
                </td>
                      <td className="overflow-hidden max-width-100px">
                  <span data-toggle="tooltip" data-placement="right" title="" data-original-title="Keithston">

                    {item?.variant?.color?.title}
                  </span>
                </td>
                      <td className="overflow-hidden max-width-100px">
                  <span data-toggle="tooltip" data-placement="right" title="" data-original-title="Keithston">

                    {item?.variant?.size?.title}
                  </span>
                </td>
                <td className="overflow-hidden max-width-100px">
                  <span data-toggle="tooltip" data-placement="right" title="" data-original-title="Keithston">

                    {item.quantity}
                  </span>
                </td>


              </tr>
            )
          })}


        </tbody>

      </table>

      <div className='d-flex align-items-end  flex-column'>
                <div className='d-flex'>
          <p className='fw-bold mx-2'>{currentLocal.home.subtotal}:</p>
          <p className='fw-semibold'>{order?.[0]?.subtotal} {currentLocal.home.egp}</p>
        </div>
        <div className='d-flex'>
          <p className='fw-bold mx-2'>{currentLocal.home.Shippingprice}:</p>
          <p className='fw-semibold'>{100} {currentLocal.home.egp}</p>
        </div>
        <div className='d-flex'>
          <p className='fw-bold mx-2'>{currentLocal.home.Totalamount}:</p>
          <p className='fw-semibold'>{order?.[0]?.total} {currentLocal.home.egp}</p>
        </div>

      </div>


    </div>
  )
}

export default OrderDetailsContainer
